<template>
  <Modal
    :value="value"
    :mask-closable="false"
    :footer-hide="true"
    width="720"
    class-name="warehouse-product-select-modal"
    @on-visible-change="onVisibleChange"
    @on-cancel="onCancel"
  >
    <div class="modal-header">
      <span class="modal-title">选择商品</span>
    </div>

    <div class="modal-body">
      <!-- 搜索栏 -->
      <div class="search-box">
        <input
          v-model="keyword"
          type="text"
          placeholder="输入商品名称搜索"
          @keyup.enter="onSearch"
        />
        <div class="search-btn" @click="onSearch">搜索</div>
      </div>

      <!-- 商品多选列表 -->
      <div class="product-list">
        <div
          v-for="(item, index) in product_list"
          :key="`p${index}`"
          class="product-item"
          :class="{ active: isSelected(item.id) }"
          @click="toggleSelect(item)"
        >
          <div class="check-box">
            <img
              v-if="isSelected(item.id)"
              src="@/assets/images/icon-checked.png"
              alt=""
            />
            <img
              v-else
              src="@/assets/images/icon-uncheck.png"
              alt=""
            />
          </div>
          <img :src="item.image" alt="" class="product-img" />
          <div class="product-text">
            <div class="p-name">{{ item.name }}</div>
            <div class="p-no">款号：{{ item.style_no || '-' }}</div>
          </div>
        </div>
        <div v-if="!product_list.length" class="empty">暂无商品</div>
      </div>
    </div>

    <div class="modal-footer">
      <span class="select-desc">
        已选 <span class="count">{{ checked_items.length }}</span> 件商品
      </span>
      <div class="footer-btns">
        <div class="btn cancel" @click="onCancel">取消</div>
        <div
          class="btn confirm"
          :class="{ disabled: !checked_items.length }"
          @click="onConfirm"
        >
          确定添加
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { WarehouseProductList } from "@/api/index";
export default {
  name: "WarehouseProductSelect",
  props: {
    // 弹窗可见性（v-model 绑定）
    value: {
      type: Boolean,
      default: false,
    },
    // 已选商品完整数组，用于打开时回显勾选态
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      keyword: "",
      product_list: [],
      checked_items: [],
    };
  },
  methods: {
    onVisibleChange(val) {
      if (val) {
        this.init();
      }
    },
    init() {
      this.keyword = "";
      // 打开时以已选商品为初始勾选态，支持回显
      this.checked_items = this.selectedItems.map((item) => ({ ...item }));
      this.searchProduct();
    },
    async searchProduct() {
      try {
        const { data } = await WarehouseProductList({ keyword: this.keyword });
        this.product_list = data.list || [];
      } catch (e) {
        console.log("e-warehouse-product-select", e);
      }
    },
    onSearch() {
      this.searchProduct();
    },
    isSelected(id) {
      return this.checked_items.some((item) => item.id == id);
    },
    toggleSelect(item) {
      const idx = this.checked_items.findIndex((sp) => sp.id == item.id);
      if (idx > -1) {
        this.checked_items.splice(idx, 1);
      } else {
        this.checked_items.push({ ...item });
      }
    },
    onCancel() {
      console.log(123)
      this.$emit("update:value", false);
    },
    onConfirm() {
      if (!this.checked_items.length) return;
      this.$emit("confirm", this.checked_items);
      this.$emit("update:value", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .warehouse-product-select-modal {
  text-align: left;
  line-height: 1.5;
  .ivu-modal-content {
    border-radius: 10px;
    overflow: hidden;
  }
  .ivu-modal-body {
    padding: 0;
  }
}
.modal-header {
  height: 56px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  .modal-title {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
  }
}
.modal-body {
  padding: 20px 24px;
  .search-box {
    display: flex;
    align-items: center;
    background: #f2f3f5;
    border-radius: 20px;
    padding: 8px 16px;
    width: 100%;
    input {
      border: none;
      outline: none;
      background: transparent;
      flex: 1;
    }
    .search-btn {
      padding-left: 16px;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;
      color: #666666;
    }
  }
  .product-list {
    max-height: 360px;
    overflow-y: auto;
    margin-top: 12px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    .product-item {
      display: flex;
      align-items: center;
      padding: 10px 14px;
      cursor: pointer;
      border-bottom: 1px solid #f5f5f5;
      &:last-child {
        border-bottom: none;
      }
      &.active {
        background: rgba(255, 89, 103, 0.06);
      }
      .check-box {
        width: 20px;
        height: 20px;
        margin-right: 12px;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .product-img {
        width: 48px;
        height: 48px;
        border-radius: 5px;
        object-fit: cover;
        margin-right: 12px;
        border: 1px solid #f0f0f0;
        flex-shrink: 0;
      }
      .product-text {
        .p-name {
          font-size: 14px;
          color: #333333;
        }
        .p-no {
          font-size: 12px;
          color: #999999;
          margin-top: 4px;
        }
      }
    }
    .empty {
      text-align: center;
      color: #999999;
      padding: 30px 0;
    }
  }
}
.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .select-desc {
    font-size: 13px;
    color: #666666;
    .count {
      color: #ff5967;
      font-weight: 600;
    }
  }
  .footer-btns {
    display: flex;
    align-items: center;
    .btn {
      width: 100px;
      height: 36px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
    }
    .cancel {
      border: 1px solid #e3e3e3;
      background: #ffffff;
      color: #999999;
      margin-right: 12px;
    }
    .confirm {
      background: #ff5967;
      color: #ffffff;
      &.disabled {
        background: #ffb3b9;
        cursor: not-allowed;
      }
    }
  }
}
</style>
